<template>
    <CieloLayout>
        <div class="payment-success">
            <TitleText level="2">
                {{ $ml.get('qrcodeTitle') }}
            </TitleText>
            <CopyQrCodeString :qr-code-string="qrCodeString" />
            <div class="payment-success-card-img">
                <img :src="qrCodeImage" class="qr-code-image" :alt="$ml.get('altQrCode')" tabindex="0" />
            </div>

            <div class="payment-success-card">
                <PaymentInstructions />

                <div class="cielo-pay-ad">
                    <span v-text="$ml.get('mobileAppAvailable')" tabindex="0" />
                </div>

                <div id="cieloLinkTarget" class="cielo-pay-ad">
                    <span v-text="$ml.get('qrcodeInstruction')" tabindex="0" />
                    <a href="https://cielo.com.br/qrcode" target="blank" tabindex="0">https://cielo.com.br/qrcode</a>
                </div>
            </div>
        </div>
    </CieloLayout>
</template>

<script>

import CopyQrCodeString from '@/components/CopyQrCodeString';
import store from '@/store';
import PaymentInstructions from '@/components/PaymentInstructions';
import CieloLayout from '@/components/layout/CieloLayout.vue';
import TitleText from '@/components/template/TitleText';

export default {
  components: {
    CopyQrCodeString,
    PaymentInstructions,
    CieloLayout,
    TitleText
  },

  computed: {
    qrCodeImage: function () {
      return `data:image/png;base64, ${store.state.qrCodePayment.Response.QrCodeBase64Image}`;
    },

    qrCodeString: function () {
      return store.state.qrCodePayment.Response.QrCodeString;
    },
  },

  beforeRouteEnter(to, from, next) {
    if (!store.state.preorder.TransactionIsFinalized)
      return next(false);

    next();
  },

  beforeRouteLeave(to, from, next) {
    if (to.name == 'OrderStatus')
      next();
    else
      next(false);
  }
};
</script>

<style lang="scss" scoped>
.payment-success {
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media screen and (max-width: 1024px) {
    align-items: center;
  }
}

.payment-success-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  padding-top: 12px;
}

.payment-success-card-img {
  display: flex;
  padding: 40px 0px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: #EFF1F3;

  @media screen and (max-width: 1024px) {
    background: none;
    padding: 0px;
  }
}

.qr-code-image {
  width: 300px;
  max-width: 90%;
}

.cielo-pay-ad {

  span {
    color: #5C6A7B;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px
  }
}
</style>
